import { Controller } from '@hotwired/stimulus'

// Existing-customer search inside the work list "Add job" flyout.
// Registered on the page wrapper (a common ancestor of the trigger button and
// the modal) so `data-action="work-list-search#open"` can resolve it. `open`
// clears the previous query/results and opens the modal, while the debounced
// `search` submits the remote search form (handled by Rails UJS).
export default class extends Controller {
  static targets = ['input', 'results', 'form', 'backdrop']

  open() {
    this.inputTarget.value = ''
    this.resultsTarget.innerHTML = ''
    this.modalControllerFor(this.backdropTarget).open()
  }

  search() {
    clearTimeout(this.timer)
    const term = this.inputTarget.value.trim()
    if (term.length >= 3) {
      this.timer = setTimeout(() => {
        this.formTarget.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
      }, 250)
    }
  }

  modalControllerFor(element) {
    return this.application.getControllerForElementAndIdentifier(element, 'modal')
  }
}
